// Fallbacks only. Live values (prices, worker share, email, videos) are edited in Admin > Settings / Media.
export const SITE_DEFAULTS = {
  currency: "₹",
  base_hourly_price: 99,
  min_hours: 1,
  worker_share: 0.6,
  business_email: "info@bookachela.com",
  cities: [{ name: "Bhopal", status: "live" }],
  media: {},
};
